import { createLifecycleFor } from 'actions/account/collections';

const TYPE = 'conditionsEstimates';

export const { callApi, patterns, replace } = createLifecycleFor(TYPE);
